var _path, _path2, _path3, _path4, _circle, _circle2, _path5, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 150,
    viewBox: "0 0 181 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M158 54V38C158 18.67 142.33 3 123 3H58C38.67 3 23 18.67 23 38V54",
    stroke: "#727272",
    strokeWidth: 6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118 111C118 96.0883 105.912 84 91 84C76.0883 84 64 96.0883 64 111",
    stroke: "#727272",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 69C4 62.9249 8.92487 58 15 58H22V98H15C8.92487 98 4 93.0751 4 87V69Z",
    fill: "#F8E837",
    stroke: "#F8E837",
    strokeWidth: 8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177 87C177 93.0751 172.075 98 166 98L159 98L159 58L166 58C172.075 58 177 62.9249 177 69L177 87Z",
    fill: "#F8E837",
    stroke: "#F8E837",
    strokeWidth: 8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 49,
    r: 11,
    fill: "#727272"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 49,
    r: 11,
    fill: "#727272"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23 102V108C23 127.33 38.67 143 58 143H86",
    stroke: "#727272",
    strokeWidth: 6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 143,
    r: 7,
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/noResults.1f774d1121f0eeb593b10c765d7cc239.svg";
export { ForwardRef as ReactComponent };